import { SecondaryStatusTag } from "@graffer-inc/console-design-kit";
import * as React from "react";
import { matchType } from "../../../application/domain/base/base-type";
import { PaymentOperationJSON } from "../../../application/domain/payment/payment-operation";

export type PaymentStatusTagProps = {
  type: PaymentOperationJSON["paymentTransactionType"];
};

export const PaymentStatusTag: React.FC<PaymentStatusTagProps> = ({ type }) => {
  return (
    <>
      {matchType(type, {
        CHARGE: <SecondaryStatusTag type="SUCCESS">決済</SecondaryStatusTag>,
        PARTIAL_REFUND: (
          <SecondaryStatusTag type="LIGHT">返金</SecondaryStatusTag>
        ),
        REFUND: <SecondaryStatusTag type="LIGHT">返金</SecondaryStatusTag>,
        ADJUST_CHARGE: (
          <SecondaryStatusTag type="SUCCESS">システム外決済</SecondaryStatusTag>
        ),
        ADJUST_REFUND: (
          <SecondaryStatusTag type="LIGHT">システム外返金</SecondaryStatusTag>
        ),
      })}
    </>
  );
};
